<template>
  <v-dialog
    v-model="value"
    persistent
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-toolbar
        dark
        color="primary"
      >
        <v-btn
          icon
          dark
          @click="handleCloseDialog"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn
            dark
            text
            @click="handleUpdateAttendance"
          >
            Save
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-container>
        <v-card class="pl-5 pr-5 ">
          <div class="mt-5">
            <v-row>
              <v-col>
                <div style="min-width:128px;min-height: 128px;">
                  <v-img
                    v-if="isError"
                    max-height="128"
                    max-width="128"
                    contain
                    :src="accountImage"
                  >
                  </v-img>
                  <v-img
                    v-else
                    max-height="128"
                    max-width="128"
                    :src="avatar"
                    :lazy-src="accountImage"
                    @error="handleError"
                  ></v-img>
                </div>
              </v-col>
              <v-col>
                <div> {{ record.userRecord.fullName }} </div>
                <div> {{ record.userRecord.userNo }} </div>
              </v-col>
            </v-row>
            <div class="text-h5 mt-1">
              Center: {{ record.center.description }}
            </div>
            <v-form ref="updateAttendanceForm">
              <v-row class="mt-1">
                <v-col>
                  <div>{{ checkinDateTimeConfig.label || checkinDateTimeConfig.toplabel }}</div>
                  <UniversalInput
                    v-model="checkinDateTime"
                    :config="checkinDateTimeConfig"
                  ></UniversalInput>
                </v-col><v-col>
                  <div>{{ checkoutDateTimeConfig.label || checkoutDateTimeConfig.toplabel }}</div>
                  <UniversalInput
                    v-model="checkoutDateTime"
                    :config="checkoutDateTimeConfig"
                  ></UniversalInput>
                </v-col>
              </v-row>
            </v-form>
          </div>
        </v-card>
        <v-card class="mt-10">
          <v-card-title>Clockin-out history</v-card-title>
          <div class="pb-2">
            <v-chip
              v-for="item in record.history"
              :key="item.id"
              outlined
            >
              {{ formatTime(item.checkTime) }}
            </v-chip>
          </div>
        </v-card>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script setup>
import { ref, onMounted, computed, toRefs, watch, onBeforeUnmount } from 'vue'
import { loadBundle } from 'firebase/firestore'
import UniversalInput from '@/components/CRUD/UniversalInput.vue'
import { formatTime, loading } from '@/utils/helper'
import { updateItem } from '@/api/coachAttendance'

const checkinDateTime = ref('')
const checkoutDateTime = ref('')

const checkinDateTimeConfig = ref({
  propName: 'checkinDateTime',
  toplabel: 'Select Checkin Time',
  required: true,
  type: {
    name: 'timepicker',
    step: 5,
  },
})
const checkoutDateTimeConfig = ref({
  propName: 'checkoutDateTime',
  toplabel: 'Select Checkout Time',
  required: true,
  type: {
    name: 'timepicker',
    step: 5,
  },
})
const updateAttendanceForm = ref(null)
const isError = ref(false)
function handleError(e) {
  isError.value = true
}

const accountImage = computed(() => require('@/assets/images/AsianAlliance/account-circle.png'))

const title = ref('Attendance Details')

const props = defineProps({
  value: {
    type: Boolean,
    default: false,
  },
  record: {
    type: Object,
    default: () => ({
      id: -1,
      userRecordID: -1, // 30040,
      centerID: -1,
      center: {
        description: '',
      },
      history: [],
      attendanceDate: '0001-01-01T00:00:00.000Z',
      checkinDateTime: '0001-01-01T00:00:00.0007Z',
      checkoutDateTime: '0001-01-01T00:00:00.0007Z',
      calculated: false,
      userRecord: {
        id: 30040,
        firstName: 'First Name', // Jason
        lastName: 'Last Name', // LI
        username: 'A230300001',
        userNo: 'A230300001',
        mobileNo: '12345678',
        fullName: 'First Name Last Name',
        avatar: 'User/Avatar/30040',
      },
    }),
  },
})

const emits = defineEmits(['input', 'close'])

function handleCloseDialog() {
  console.log('handleCloseDialog')
  emits('input', false)
  emits('close')
}

const { value, record } = toRefs(props)

const avatar = computed(() => process.env.VUE_APP_BASE_API + record.value.userRecord.avatar || 'https://cdn.vuetifyjs.com/images/lists/1.jpg')

function handleUpdateAttendance() {
  console.log('handleUpdateAttendance')

  const formValidateResult = updateAttendanceForm.value.validate()
  console.log('formValidateResult', formValidateResult)
  if (!formValidateResult) {
    return ''
  }
  loading(true)
  updateItem({
    id: record.value.id,
    checkinDateTime: checkinDateTime.value,
    checkoutDateTime: checkoutDateTime.value,
  }).then(res => {
    console.log('res', res)
    handleCloseDialog()
  }).catch(err => {
    console.log('err', err)
  }).finally(() => {
    loading(false)
  })
}

watch(record, newVal => {
  console.log('record', newVal)
  checkinDateTime.value = newVal.checkinDateTime
  checkoutDateTime.value = newVal.checkoutDateTime
})
</script>
